import ScalarIconArrowUpRight_vue_vue_type_script_setup_true_lang_default from "./ScalarIconArrowUpRight.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconArrowUpRight.vue
var ScalarIconArrowUpRight_default = ScalarIconArrowUpRight_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconArrowUpRight_default as default };

//# sourceMappingURL=ScalarIconArrowUpRight.js.map